enum NumberStyleEnum {
	percent = 'percent'
}

export default NumberStyleEnum